<div class="flex flex-col p-5 gap-[10px]">
  <h3
  class="font-bold text-[24px] leading-[32px] text-center"
  >Why is this comment inaccurate?</h3>
  <div>{{'@' + comment?.moderatorNickname}} 
    <span 
    class="font-normal text-[14px] leading-[24px] text-[#BEB9B4]"
    >{{comment?.moderationDatetime | date: 'MMM d'}}
    </span>
  </div>
  <div 
  class="font-normal text-[16px] leading-[21px] text-[#636363]"
  >
  {{comment?.moderationReason}}
  </div>
  <h3 class="font-bold text-[24px] leading-[32px] text-center">
    Do you agree with this reason for moderating this comment?
  </h3>
  <div class="flex flex-row gap-[20px] align-center justify-center w-full">
    <ark-button size="medium" class="w-full" (click)="moderateCommentDownvote()">I AGREE</ark-button>
    <ark-button size="medium" class="w-full" (click)="moderateCommentUpvote()">I DISAGREE</ark-button>
  </div>
</div>